/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirming_Perchase_TitleInputs */

const en_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirming Purchase`)
};

const ar_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تأكيد الشراء`)
};

const de_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf wird bestätigt`)
};

const es_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmando compra`)
};

const fr_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation de l’achat`)
};

const it_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma acquisto`)
};

const ja_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入を確認中`)
};

const ko_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 확인 중`)
};

const pt_br_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmando compra`)
};

const ru_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждаем покупку`)
};

const th_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังยืนยันการซื้อ`)
};

const tr_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın Alma Onaylanıyor`)
};

const zh_cn_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买确认中`)
};

const zh_tw_dialog_confirming_perchase_title = /** @type {(inputs: Dialog_Confirming_Perchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購買確認中`)
};

/**
* | output |
* | --- |
* | "Confirming Purchase" |
*
* @param {Dialog_Confirming_Perchase_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirming_perchase_title = /** @type {((inputs?: Dialog_Confirming_Perchase_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirming_Perchase_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirming_perchase_title(inputs)
	if (locale === "ar") return ar_dialog_confirming_perchase_title(inputs)
	if (locale === "de") return de_dialog_confirming_perchase_title(inputs)
	if (locale === "es") return es_dialog_confirming_perchase_title(inputs)
	if (locale === "fr") return fr_dialog_confirming_perchase_title(inputs)
	if (locale === "it") return it_dialog_confirming_perchase_title(inputs)
	if (locale === "ja") return ja_dialog_confirming_perchase_title(inputs)
	if (locale === "ko") return ko_dialog_confirming_perchase_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirming_perchase_title(inputs)
	if (locale === "ru") return ru_dialog_confirming_perchase_title(inputs)
	if (locale === "th") return th_dialog_confirming_perchase_title(inputs)
	if (locale === "tr") return tr_dialog_confirming_perchase_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirming_perchase_title(inputs)
	return zh_tw_dialog_confirming_perchase_title(inputs)
});